import { render, staticRenderFns } from "./ConfigCourseHoleInfoPopup.vue?vue&type=template&id=484c9c01&"
import script from "./ConfigCourseHoleInfoPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigCourseHoleInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports